import { useLoginForm } from '../../../hooks/auth/useLoginForm';
import { useLoginKuitanAgent } from '../../../hooks/auth/useLoginKuitanAgent';
import { LoginForm } from '../../organisms/authentication/LoginForm';


export const LoginKuitanAgent = () => {
  const { handleSubmit, register, isSubmitting, errors } = useLoginForm();
  const onSubmit = useLoginKuitanAgent();
  return <LoginForm onSubmit={handleSubmit(onSubmit)} register={register} errors={errors} isSubmitting={isSubmitting} title="エージェントログイン" btnColor="red" />
};